import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import { FormControl } from 'react-bootstrap';
import { useFormik } from "formik";
import { withTranslation } from 'react-i18next';
import * as Yup from "yup";
import { Helmet } from 'react-helmet';
import { getIconPath } from "../../helpers/file_helper";
import { filter } from 'lodash/collection'
import { get } from 'lodash/object'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';
import { Button, Container, Spinner } from 'reactstrap';
import BreadCrumb from '../../Components/Common/BreadCrumb';
import { toast } from 'react-toastify';
import { createTimeline, getTimeline, updateTimeline } from '../../api/casp/timeline';
import { useSelector } from 'react-redux';
import { Action } from '../../constants/Common';

function ProjectTimeline(props) {
    const [projectCreationLoading, setProjectCreationLoading] = useState(false);
    const [action, setAction] = useState()
    const loggedInUser = useSelector((state) => state.Profile.user);
    const initialProjectObject = {
        startDate: "",
        endDate: "",
    }
    const projectBasicFieldValidation = Yup.object().shape({
        startDate: Yup.date().typeError(props.t("Given date is invalid type")).required(props.t("Please enter start date")),
        endDate: Yup.date()
            .typeError(props.t("Given date is invalid type"))
            .required(props.t("Please enter end date"))
            .min(Yup.ref("startDate"), props.t("End date cannot be before Start date"))
    })
    const formik = useFormik({
        initialValues: {
            ...initialProjectObject,
        },
        validationSchema: projectBasicFieldValidation,
        validateOnMount: true,
    });

    useEffect(() => {
        fetchTimeline();
        }, [])
    const handleCreate = async () => {
            try {
                setProjectCreationLoading(true);
                const payload = {
                    companyId: loggedInUser?.company?.id,
                    startDate: formik.values.startDate,
                    endDate: formik.values.endDate,
                };

                const response = await createTimeline(payload);
                if (response.statusCode === 200) {

                        toast.success(response.data.message)
                        // handleCancel('success');
                } else {
                    toast.error(response.data.message);
                }
            } catch (error) {
                toast.error(error.message);
            } finally {
                setProjectCreationLoading(false);
            }
        };

    const fetchTimeline = async () => {
            try {
                setProjectCreationLoading(true);
                const companyId = loggedInUser?.company?.id
                const res = (await getTimeline(companyId)).data.data;
                if(res) {
                    setAction(Action.EDIT)
                    formik.setValues({
                        startDate: dayjs(res.startDate).format('MM/DD/YYYY'),
                        endDate: dayjs(res.endDate).format('MM/DD/YYYY'),
                    })
                }
            } catch (error) {
                toast.error(error.message)
            } finally {
                setProjectCreationLoading(false)
            }
        }
    
    const handleEdit = async () => {
            try {
                setProjectCreationLoading(true);
                const payload = {
                    startDate: dayjs(formik.values.startDate).format("YYYY-MM-DD"),
                    endDate: dayjs(formik.values.endDate).format("YYYY-MM-DD"),
                };
                const companyId = loggedInUser?.company?.id
    
                const response = await updateTimeline(payload, companyId);
                if (response.statusCode === 200) {
                    toast.success(response.data.message);
                } else {
                    toast.error(response.data.message);
                }
            } catch (error) {
                toast.error(error.message);
            } finally {
                setProjectCreationLoading(false);
        }
    }
    
    return (
        <React.Fragment>
            <div className="page-content position-relative">
                <Helmet
                    onChangeClientState={(newState, addedTags) => {
                        try {
                            // Check if we added any new link[rel="icon"] elements.
                            const newFaviconElems = filter(get(newState, 'linkTags', []), {
                                rel: 'icon',
                            })

                            if (!newFaviconElems.length) {
                                return
                            }

                            // Get the href of the last link element we just added, which
                            // we assume is the most recently-added favicon.
                            const newFaviconHref =
                                newFaviconElems[newFaviconElems.length - 1].href

                            // Remove all react-helmet link elements with rel="icon" that
                            // do not have the href of our recently-added favicon.
                            // If no other favicon elements exist, we don't have to do
                            // anything.
                            const existingFavicons = document.querySelectorAll(
                                `link[rel="icon"][data-react-helmet]:not([href="${newFaviconHref}"])`
                            )

                            if (existingFavicons.length) {
                                existingFavicons.forEach(e => e.parentNode.removeChild(e))
                            }

                            // Remove and re-add the latest link element to make sure
                            // the browser uses it.
                            const newFaviconElem = document.querySelector(
                                `link[rel="icon"][data-react-helmet][href="${newFaviconHref}"]`
                            )

                            if (newFaviconElem) {
                                const newFavElement = newFaviconElem.cloneNode(true)
                                newFavElement.href = `data:image/svg+xml,${encodeURIComponent(
                                    `<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'>${getIconPath(<SettingsOutlinedIcon />)}</svg>`
                                )}`
                                const parentElem = newFaviconElem.parentNode
                                parentElem.removeChild(newFaviconElem)
                                parentElem.appendChild(newFavElement)
                            }
                        } catch (e) {
                            console.error(e)
                        }
                    }}
                >
                    <title>{props.t("Startup Type")}</title>
                </Helmet>
                <Container fluid>
                    <div className="mainPageHeader d-flex justify-content-between">
                        <BreadCrumb
                            title={props.t("Startup Timeline")}
                        />

                        {/* <TextField id="outlined-basic" label="Outlined" variant="outlined" placeholder="Search..." /> */}
                    </div>
                    <div className="col-sm-6 mb-3 pe-2 plDatepicker">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={["DatePicker"]}>
                                <DatePicker
                                    sx={{ mb: 1 }}
                                    label={props.t("Start Date") + ' *'}
                                    className="form-control"
                                    format="MM/DD/YYYY"
                                    name="startDate"
                                    value={
                                        formik?.values?.startDate?.toString().trim()
                                            ? dayjs(formik.values.startDate)
                                            : null
                                    }
                                    slotProps={{
                                        field: {
                                            clearable: true,
                                            onBlur: (_) => {
                                                if (!formik.touched?.startDate) {
                                                    formik.setFieldTouched("startDate", true, false);
                                                }
                                            },
                                        },
                                        onClear: () => {
                                            formik.setFieldValue("startDate", "");
                                        },
                                    }}
                                    onChange={(e) => {
                                        formik.setFieldValue(
                                            "startDate",
                                            e ? dayjs(e).format("YYYY-MM-DD") : ""
                                        );
                                        if (!formik.touched?.startDate) {
                                            formik.setFieldTouched("startDate", true, false);
                                        }
                                    }}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                        {formik.touched.startDate && formik.errors.startDate && (
                            <span className="text-danger d-block">
                                {formik.errors.startDate}
                            </span>
                        )}
                    </div>
                    <div className="col-sm-6 mb-3 pe-2 plDatepicker">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={["DatePicker"]}>
                                <DatePicker
                                    sx={{ mb: 1 }}
                                    label={props.t("End Date") + ' *'}
                                    className="form-control"
                                    format="MM/DD/YYYY"
                                    name="endDate"
                                    value={
                                        formik?.values?.endDate?.toString().trim()
                                            ? dayjs(formik.values.endDate)
                                            : null
                                    }
                                    slotProps={{
                                        field: {
                                            clearable: true,
                                            onBlur: (_) => {
                                                if (!formik.touched?.endDate) {
                                                    formik.setFieldTouched("endDate", true, false);
                                                }
                                            },
                                        },
                                        onClear: () => {
                                            formik.setFieldValue("endDate", "");
                                        },
                                    }}
                                    onChange={(e) => {
                                        formik.setFieldValue(
                                            "endDate",
                                            e ? dayjs(e).format("YYYY-MM-DD") : ""
                                        );
                                        if (!formik.touched?.startDate) {
                                            formik.setFieldTouched("endDate", true, false);
                                        }
                                    }}
                                />
                            </DemoContainer>
                        </LocalizationProvider>
                        {formik.touched.startDate && formik.errors.endDate && (
                            <span className="text-danger d-block">
                                {formik.errors.endDate}
                            </span>
                        )}
                    </div>
                    <div className="plsubmitButton">
                        <Button
                            className="btn addNew_ProjectBtn"
                            disabled={projectCreationLoading || !formik.isValid}
                            type="submit"
                            onClick={action === Action.EDIT ? handleEdit : handleCreate}
                        >
                            {projectCreationLoading && (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-1"
                                />
                            )}
                            {props.t('Submit')}
                        </Button>
                    </div>
                </Container>

            </div>
        </React.Fragment>
    )
}

export default withTranslation()(ProjectTimeline)
